import { contactInfo } from '@/mocks/homeData';

export default function ContactSection() {
  return (
    <section id="contact" className="py-14 md:py-20 px-4 md:px-6 bg-background-100">
      <div className="max-w-[800px] mx-auto">
        <div className="text-center mb-10 md:mb-14">
          <span className="inline-block px-3 py-1 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium mb-3">
            保持联系
          </span>
          <h2 className="text-2xl md:text-3xl lg:text-4xl font-heading font-bold text-foreground-950">
            {contactInfo.title}
          </h2>
          <p className="mt-2 text-sm md:text-base text-foreground-600">
            {contactInfo.subtitle}
          </p>
        </div>

        <div className="bg-background-50 rounded-2xl p-8 md:p-10">
          <p className="text-sm md:text-base text-foreground-700 leading-relaxed mb-8 text-center max-w-[560px] mx-auto">
            {contactInfo.description}
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 md:gap-6">
            <div className="flex items-center gap-3 bg-background-100 rounded-xl px-5 py-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-primary-100 text-primary-600">
                <i className="ri-mail-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-500">投稿与合作邮箱</div>
                <div className="text-sm font-medium text-foreground-900">{contactInfo.email}</div>
              </div>
            </div>

            <div className="flex items-center gap-3 bg-background-100 rounded-xl px-5 py-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600">
                <i className="ri-time-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-500">工作时间</div>
                <div className="text-sm font-medium text-foreground-900">工作日 9:00 – 18:00</div>
              </div>
            </div>

            <div className="flex items-center gap-3 bg-background-100 rounded-xl px-5 py-3">
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-secondary-100 text-secondary-600">
                <i className="ri-chat-1-line text-lg"></i>
              </div>
              <div>
                <div className="text-xs text-foreground-500">回复时效</div>
                <div className="text-sm font-medium text-foreground-900">{contactInfo.responseTime}</div>
              </div>
            </div>
          </div>

          <div className="mt-8 pt-6 border-t border-background-200/70 text-center">
            <p className="text-xs text-foreground-500">
              我们重视每一位读者的声音。无论是内容建议、投稿意向还是合作洽谈，欢迎随时与我们联系。
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}